import { FC } from "react";

import Head from "next/head";

import { HeadProps } from "@/props/HeadProps";

const HeadLayout: FC<HeadProps> = ({ title, description }) => {
    return (
        <Head>
            <title>{title}</title>
            <meta name="description" content={description} />
        </Head>
    );
};

export default HeadLayout;